import * as actions from './actions';

const initialState = {
  // Anonymous per-reading purchase (contrato de PayToGenerateFlow)
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
  paidReading: null,
  // Extra de nahual: el signo calculado al crear la carta (para el preview)
  nahualLabel: null,
  signoSlug: null,
};

export default function nahualChartReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_PENDING_NAHUAL_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null };
    case actions.CREATE_PENDING_NAHUAL_SUCCESS:
      return {
        ...state,
        pendingLoading: false,
        pendingReadingId: action.payload.readingId,
        nahualLabel: action.payload.nahualLabel,
        signoSlug: action.payload.signoSlug,
      };
    case actions.CREATE_PENDING_NAHUAL_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.NAHUAL_CHECKOUT_REQUEST:
    case actions.NAHUAL_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.NAHUAL_CHECKOUT_SUCCESS:
    case actions.NAHUAL_PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.NAHUAL_CHECKOUT_FAILURE:
    case actions.NAHUAL_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.NAHUAL_VERIFY_REQUEST:
    case actions.NAHUAL_VERIFY_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.NAHUAL_VERIFY_SUCCESS:
    case actions.NAHUAL_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
        paidReading: action.payload.reading || state.paidReading,
      };
    case actions.NAHUAL_VERIFY_FAILURE:
    case actions.NAHUAL_VERIFY_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    default:
      return state;
  }
}
